// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* P4b: Watchlist panel */
/* UI_P3B: column header + rows + details share one column track layout. */
.YABogEnYpZU43WpHJC9g {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.dF9KacB8ym40IpokaUBQ {
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: var(--vnsc-bg-primary, #131722);
  border-bottom: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
  font-variant-numeric: tabular-nums;
}

.REJhiFeBEtL8BeOG4Ax9 {
  flex: 1;
  min-width: 0;
}

.mD1YnNE6906cRNYXGQOR {
  flex-shrink: 0;
  width: 50px;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.NeQIhFzAV3c_0hVaXQL8 {
  display: flex;
  flex-direction: column;
  padding: 4px 4px 12px;
  gap: 1px;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--vnsc-border, #2a3550) transparent;
}

.NeQIhFzAV3c_0hVaXQL8::-webkit-scrollbar {
  width: 8px;
}

.NeQIhFzAV3c_0hVaXQL8::-webkit-scrollbar-thumb {
  background: var(--vnsc-border, #2a3550);
  border-radius: 8px;
}

.NeQIhFzAV3c_0hVaXQL8::-webkit-scrollbar-corner {
  background: transparent;
}

.eFASBjU4el9zZpwmpnPm {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-height: 34px;
  padding: 3px 8px;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));
  border-radius: 0;
  cursor: pointer;
  text-align: left;
  font-variant-numeric: tabular-nums;
}

.eFASBjU4el9zZpwmpnPm:last-child {
  border-bottom: none;
}

.eFASBjU4el9zZpwmpnPm:hover {
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}

/* D3: visible keyboard focus for the APG listbox (div rows, not buttons). */
.eFASBjU4el9zZpwmpnPm:focus {
  outline: none;
}

.eFASBjU4el9zZpwmpnPm:focus-visible {
  outline: 2px solid var(--vnsc-accent-strong, #2563eb);
  outline-offset: -2px;
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}

.QIKQ1W5QJolxEne7XECL {
  background: var(--vnsc-bg-selected, rgba(59, 130, 246, 0.15));
}

.oAmNNf8u4DYhUfdHff4N {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}

.xmXky6lZv352BAjd30p8 {
  font-size: 12px;
  font-weight: 700;
  color: var(--vnsc-text-primary, #d1d4dc);
  white-space: nowrap;
}

.Iky0QOmltxsLejKPgHIg {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.VmPPhcN9heYXQ8oKLAMP {
  flex-shrink: 0;
  color: var(--vnsc-text-secondary, #787b86);
}

.wlzUedZDwz6amRVc8QyV {
  flex-shrink: 0;
  width: 50px;
  min-width: 0;
  text-align: right;
  font-size: 11px;
  color: var(--vnsc-text-primary, #d1d4dc);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gvLkZKoyyTlk7H0jxpRq {
  color: var(--vnsc-color-bullish, rgb(38, 166, 154));
}

.Z1wBC9hkOHoRsiPHO7MY {
  color: var(--vnsc-color-bearish, rgb(239, 83, 80));
}

.MgWuDfkEhXPl1i5zpYJw {
  padding: 16px 12px;
  font-size: 12px;
  color: var(--vnsc-text-secondary, #787b86);
  text-align: center;
}

/* UI_P3B: sticky bottom details for the active watchlist symbol. */
.Mvq8HGbyQqnpqcdw5JgN {
  position: sticky;
  bottom: 0;
  z-index: 1;
  margin-top: auto;
  padding: 8px;
  background: var(--vnsc-bg-primary, #131722);
  border-top: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));
}

.f6HWvhZ0n28cBip2bsOr {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.mJoqK3FHIfiJnu1jZ14g {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.f6QVQJqgpjeSk3LHKkEV {
  font-size: 12px;
  font-weight: 700;
  color: var(--vnsc-text-primary, #d1d4dc);
  white-space: nowrap;
}

.Qpoq3_EFvHDoSpxtt7oS {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.y1gjq2lxItMBaXzJLXfm {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
}

.HY4FsDb5GLAXR2mox9Aw {
  font-size: 12px;
  font-weight: 600;
  color: var(--vnsc-text-primary, #d1d4dc);
}

.CrCwYNbLbvx04hDl2NV9,
._5O9Bh3Y9ig4B2jnEpgX {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
}

.GVI7FK3a2Eick22MbPfj {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 4px;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));
}

.pT_fEcLlkUDBtg_j_G80 {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.PW5bO7RP1cw9g7XhfKPm {
  font-size: 9px;
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ZQUuBYPj8kpEIguxpB9j {
  font-size: 10px;
  color: var(--vnsc-text-primary, #d1d4dc);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mrPnh2NdCBCIviBddm31 {
  padding-top: 6px;
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/watchlist-panel.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB,0EAA0E;AAC1E;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,2CAA2C;EAC3C,0EAA0E;EAC1E,eAAe;EACf,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,0EAA0E;EAC1E,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA,4EAA4E;AAC5E;EACE,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C,uEAAuE;AACzE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;;EAEE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uEAAuE;AACzE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;AACpB","sourcesContent":["/* P4b: Watchlist panel */\r\n/* UI_P3B: column header + rows + details share one column track layout. */\r\n.root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100%;\r\n}\r\n\r\n.colHead {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  background: var(--vnsc-bg-primary, #131722);\r\n  border-bottom: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.colHeadName {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.col {\r\n  flex-shrink: 0;\r\n  width: 50px;\r\n  text-align: right;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 4px 4px 12px;\r\n  gap: 1px;\r\n  overflow-x: hidden;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: var(--vnsc-border, #2a3550) transparent;\r\n}\r\n\r\n.list::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.list::-webkit-scrollbar-thumb {\r\n  background: var(--vnsc-border, #2a3550);\r\n  border-radius: 8px;\r\n}\r\n\r\n.list::-webkit-scrollbar-corner {\r\n  background: transparent;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  width: 100%;\r\n  min-height: 34px;\r\n  padding: 3px 8px;\r\n  background: transparent;\r\n  border: none;\r\n  border-bottom: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));\r\n  border-radius: 0;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.row:hover {\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\r\n}\r\n\r\n/* D3: visible keyboard focus for the APG listbox (div rows, not buttons). */\r\n.row:focus {\r\n  outline: none;\r\n}\r\n\r\n.row:focus-visible {\r\n  outline: 2px solid var(--vnsc-accent-strong, #2563eb);\r\n  outline-offset: -2px;\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\r\n}\r\n\r\n.rowActive {\r\n  background: var(--vnsc-bg-selected, rgba(59, 130, 246, 0.15));\r\n}\r\n\r\n.symBlock {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  flex: 1;\r\n}\r\n\r\n.sym {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  white-space: nowrap;\r\n}\r\n\r\n.name {\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.spark {\r\n  flex-shrink: 0;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.cell {\r\n  flex-shrink: 0;\r\n  width: 50px;\r\n  min-width: 0;\r\n  text-align: right;\r\n  font-size: 11px;\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.up {\r\n  color: var(--vnsc-color-bullish, rgb(38, 166, 154));\r\n}\r\n\r\n.down {\r\n  color: var(--vnsc-color-bearish, rgb(239, 83, 80));\r\n}\r\n\r\n.empty {\r\n  padding: 16px 12px;\r\n  font-size: 12px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  text-align: center;\r\n}\r\n\r\n/* UI_P3B: sticky bottom details for the active watchlist symbol. */\r\n.details {\r\n  position: sticky;\r\n  bottom: 0;\r\n  z-index: 1;\r\n  margin-top: auto;\r\n  padding: 8px;\r\n  background: var(--vnsc-bg-primary, #131722);\r\n  border-top: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));\r\n}\r\n\r\n.detailsHead {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  min-width: 0;\r\n}\r\n\r\n.detailsSymBlock {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.detailsSym {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  white-space: nowrap;\r\n}\r\n\r\n.detailsName {\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.detailsQuote {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.detailsLast {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n}\r\n\r\n.detailsChg,\r\n.detailsPct {\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.detailGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(5, minmax(0, 1fr));\r\n  gap: 4px;\r\n  margin-top: 6px;\r\n  padding-top: 6px;\r\n  border-top: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));\r\n}\r\n\r\n.detailCell {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.detailLabel {\r\n  font-size: 9px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.detailValue {\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.detailsEmpty {\r\n  padding-top: 6px;\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `YABogEnYpZU43WpHJC9g`,
	"colHead": `dF9KacB8ym40IpokaUBQ`,
	"colHeadName": `REJhiFeBEtL8BeOG4Ax9`,
	"col": `mD1YnNE6906cRNYXGQOR`,
	"list": `NeQIhFzAV3c_0hVaXQL8`,
	"row": `eFASBjU4el9zZpwmpnPm`,
	"rowActive": `QIKQ1W5QJolxEne7XECL`,
	"symBlock": `oAmNNf8u4DYhUfdHff4N`,
	"sym": `xmXky6lZv352BAjd30p8`,
	"name": `Iky0QOmltxsLejKPgHIg`,
	"spark": `VmPPhcN9heYXQ8oKLAMP`,
	"cell": `wlzUedZDwz6amRVc8QyV`,
	"up": `gvLkZKoyyTlk7H0jxpRq`,
	"down": `Z1wBC9hkOHoRsiPHO7MY`,
	"empty": `MgWuDfkEhXPl1i5zpYJw`,
	"details": `Mvq8HGbyQqnpqcdw5JgN`,
	"detailsHead": `f6HWvhZ0n28cBip2bsOr`,
	"detailsSymBlock": `mJoqK3FHIfiJnu1jZ14g`,
	"detailsSym": `f6QVQJqgpjeSk3LHKkEV`,
	"detailsName": `Qpoq3_EFvHDoSpxtt7oS`,
	"detailsQuote": `y1gjq2lxItMBaXzJLXfm`,
	"detailsLast": `HY4FsDb5GLAXR2mox9Aw`,
	"detailsChg": `CrCwYNbLbvx04hDl2NV9`,
	"detailsPct": `_5O9Bh3Y9ig4B2jnEpgX`,
	"detailGrid": `GVI7FK3a2Eick22MbPfj`,
	"detailCell": `pT_fEcLlkUDBtg_j_G80`,
	"detailLabel": `PW5bO7RP1cw9g7XhfKPm`,
	"detailValue": `ZQUuBYPj8kpEIguxpB9j`,
	"detailsEmpty": `mrPnh2NdCBCIviBddm31`
};
export default ___CSS_LOADER_EXPORT___;
